import React from 'react';
import ModernProfileContainer from './ModernProfileContainer';

function ProfilePage() {
  return <ModernProfileContainer />;
}

export default ProfilePage; 